import {ActionList, ActionMenu, IconButton} from '@primer/react'
import {KebabHorizontalIcon, StackRemoveIcon} from '@primer/octicons-react'
import type {RefObject} from 'react'

type StackActionsMenuProps = {
  anchorRef: RefObject<HTMLButtonElement | null>
  onUnstack: () => void
  unstackInactiveText?: string
}

export function StackActionsMenu({anchorRef, onUnstack, unstackInactiveText}: StackActionsMenuProps) {
  return (
    <ActionMenu anchorRef={anchorRef}>
      <ActionMenu.Anchor>
        <IconButton ref={anchorRef} icon={KebabHorizontalIcon} variant="invisible" aria-label="More options" />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay align="end">
        <ActionList>
          <ActionList.Item variant="danger" onSelect={onUnstack} inactiveText={unstackInactiveText}>
            <ActionList.LeadingVisual>
              <StackRemoveIcon />
            </ActionList.LeadingVisual>
            Unstack pull requests
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
